<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <Search />
        <v-data-table
          class="elevation-0"
          :headers="table.header"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.inputPage.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50, 100],showFirstLastPage: true, showCurrentPage: true }"
        >
          <template v-slot:item.name="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >{{ item.name }}</span>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.email="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >{{ item.email }}</span>
              </template>
              <span>{{ item.email }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.token="{ item }">
            <div class="d-flex align-center">
              <span>••••••••••</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    :loading="copyingTokenId === item.id"
                    v-bind="attrs"
                    v-on="on"
                    @click="copyToken(item)"
                  >
                    <v-icon small>content_copy</v-icon>
                  </v-btn>
                </template>
                <span>Copiar token</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <router-link
              v-hasPrivilleges="'update_company'"
              :to="{ name: 'dashboard-empresas-editar', params: { id: item.id } }"
              title="Editar Transportadora"
            >
              <v-icon>edit</v-icon>
            </router-link>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import Service from '@/services/empresa.service';
  import Search from './Search';

  export default {
    components: {
      Search
    },
    data: () => ({
      pagination: null,
      copyingTokenId: null
    }),
    computed: {
      ...mapState('empresa', ['table'])
    },
    watch: {
      pagination: {
        handler() {
          this.changePagination();
        },
        deep: true
      }
    },
    destroyed() {
      this.clear();
    },
    methods: {
      async copyToken(item) {
        this.copyingTokenId = item.id;
        try {
          const data = await Service.token(item.id).toPromise();          
          if (!data.token) {
            this.$store.commit('global/setSnackBar', { show: true, message: 'Esta transportadora não possui token', type: 'error' });
            return;
          }
          if (navigator.clipboard) {
            await navigator.clipboard.writeText(data.token);
          } else {
            const textarea = document.createElement('textarea');            
            textarea.value = data.token;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
          }
          this.$store.commit('global/setSnackBar', { show: true, message: 'Token copiado com sucesso', type: 'success' });
        } catch (e) {          
          this.$store.commit('global/setSnackBar', { show: true, message: 'Não foi possível copiar o token', type: 'error' });
        } finally {
          this.copyingTokenId = null;
        }
      },
      changePagination() {
        const { page, itemsPerPage } = this.pagination;
        const paginate = {
          ...this.table.paginate,
          inputPage: {
            page: page,
            per_page: itemsPerPage,
            sort: 'id:desc'         
          }
        };
        this.changePage(paginate);
        this.search();
      },
      ...mapActions('empresa', { search: 'SEARCH' }),
      ...mapActions('empresa', { clear: 'CLEAR' }),
      ...mapActions('empresa', { changePage: 'CHANGE_PAGE' })
    },
  };
</script>
